import { Locales, Locale } from '@amzn/xb-hooks';
import { rumService } from '../services/rum';
import metricsService from '../services/metrics';

export const DEFAULT_LOCALE = Locales.ENGLISH;

export const getSafeLocale = (
  locale: Locale,
  sourceComponent: string,
  supportedLocales = Locales.asList()
) => {
  const supportedLocalesLookup = Locales.lookupFor(supportedLocales);
  let safeLocale = locale;
  if (!supportedLocalesLookup(locale?.code)) {
    // empty locale is expected if authentication is loading
    if (locale?.code) {
      const urlParams = new URLSearchParams(window.location.search);
      const clientId = urlParams.get('client_id') || 'NA';
      rumService.recordEvent('UnsupportedLocale', {
        unsupportedLocale: locale.code,
        sourceComponent: sourceComponent,
        clientId: clientId,
      });
    }
    safeLocale = DEFAULT_LOCALE;
  }

  return safeLocale;
};

export const getLocaleItems = (
  localeCode: string,
  idSeparator: string,
  locales: Locale[]
) => {
  return [
    ...locales.map((l) => ({
      text: l.displayName,
      id: `header-localeItem${idSeparator}${l.code}`,
      disabled: localeCode === l.code,
      lang: l.code,
    })),
  ];
};

export const getHandleLocaleChange = (
  event: any,
  setLocale,
  localeLookup,
  idSeparator: string
) => {
  const selectedLocaleCode = event.detail.id.replace(
    `header-localeItem${idSeparator}`,
    ''
  );
  const selectedLocale = localeLookup(selectedLocaleCode);
  if (selectedLocale) {
    setLocale(selectedLocale);
    const publisher = metricsService.getPublisher('LocaleMenu');
    publisher.publishCounterMonitor('ClickLocale', 1);
    publisher.publishStringTruncate('SelectedLocale', selectedLocale.code);
  }
};
